// import RulePack from './RulePack';

export default {
  priority: 3,
  path: "packet",
  permissions: ["TimeAttendanceMenu/SmsMenu/SmsDefinitionMenu"],
  // component: RulePack,
  component: load(() =>
    import(/* webpackChunkName: "Request-pattern-RulePack" */ "./Definition")
  ),
  name: app.translate("routes.home.requests.Definition"),
  icon: "content-paste",
  drawer: true,
};
